import axiosInstance from './../utils/axios';

export const apiClient = {
  get: (url, params = {}) => axiosInstance.get(url, { params }),
  post: (url, data) => axiosInstance.post(url, data),
  put: (url, data) => axiosInstance.put(url, data),
  patch: (url, data) => axiosInstance.put(url, data),
  delete: (url) => axiosInstance.delete(url),
};
